import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';

const SchoolProfileSkeleton = () => {
  return (
    <Box
      sx={{
        maxWidth: '800px',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      {/* Nachricht basierend auf Ladezustand */}
      <Box
        sx={{
          padding: '1rem',
          borderRadius: '8px',
          color: '#ff9800',
          mt: '1rem',
        }}
      >
        <Skeleton variant="text" width="60%" />
        <Skeleton variant="text" width="80%" />
      </Box>

      {/* Platzhalteranzeige */}
      <Box
        sx={{
          position: 'relative',
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '1rem',
        }}
      >

        {/* Verschwommene Balken als Platzhalter */}
        {[
          'Schullogo/-flagge',
          'Name der Schule',
          'Identifikationsnummer',
          'Straße',
          'PLZ',
          'Ort',
          'E-Mail',
          'Telefonnummer',
        ].map((label, index) => (
          <Box
            key={index}
            sx={{
              marginBottom: '1rem',
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 'bold', color: '#3f51b5' }}
            >
              {label}:
            </Typography>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="1.5rem"
              sx={{ borderRadius: '4px' }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SchoolProfileSkeleton;
